import ajax from './http'

/*****公共接口******/
//获取账号信息
export function getAcconutInfo() {
  return ajax({
    url: "/system/users/getAccountInfo",
    type: "GET",
    data: {}
  })
}
//修改账号信息
export function changeAcconutInfo(data) {
  return ajax({
    url: "/system/users/modifyAccount",
    type: "POST",
    data
  })
}
//文件上传
export function uploadFile(formData, onUploadProgress) {
  return ajax({
    url: "/upload/common",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//视频上传
export function uploadVideoFile(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/uploadProductVideo",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//oss视频上传
export function uploadOssVideoFile(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/mulipartV2/pm",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
// 上传视频转
export function uploadVideoToM3u8(formData, onUploadProgress) {
  return ajax({
    type: "POST",
    url: "/upload/mulipart/video/transcode",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}

//获取系统所有权限
export function getAdmin() {
  return ajax({
    url: "/system/sysPerms/read/all",
    data: {}
  })
}

// 系统所有角色
export function getRolesType() {
  return ajax({
    url: "/system/info/role",
    type: "GET",

  })
}
// 系统所有角色
export function getRoles(data) {
  return ajax({
    url: "/system/sysRoles/read/list",
    data
  })
}
//用户下所有角色
export function getUserRoles(userId) {
  return ajax({
    url: `/system/sysUsers/read/roles`,
    type: "get",
    data: {
      userId
    }
  })
}
//保存用户角色
export function saveUserRoles(userId, roleIds) {
  return ajax({
    url: `/system/sysUsers/save/roles`,
    data: {
      userId,
      roleIds,
    },
  })
}
//移除用户角色

export function removeUserRoles(userId) {
  return ajax({
    url: `/system/users/batchDel/roles`,
    type: "get",
    data: {
      userId
    },
  })
}
//删除用户
export function removeUser(id) {
  return ajax({
    url: "/system/sysUsers/del",
    type: "get",
    data: {
      id
    },
  })
}

//新增编辑角色
export function removeUserOrEditRoles(type, obj) {
  return ajax({
    url: `/system/sysUsers/${type}`,
    data: {
      ...obj
    },
  })
}

/*****首页******/
export function getIndexData(timeType, organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/policy/queryHomeStatistics`,
    data: {
      timeType,
      organizationId
    },
  })
}
// 首页客户成交统计
export function getHolderCount(organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/holder/getHolderCount`,
    data:{
      organizationId
    }
  })
}
// 首页保单保费统计
export function getAllPolicyStatistics(organizationId) {
  return ajax({
    type: "GET",
    url: `/buz/policy/getAllPolicyStatistics`,
    data:{
      organizationId
    }
  })
}

/*****菜单管理******/

//增
export function menuManage_add(obj) {
  return ajax({
    type: "POST",
    url: "/system/sysMenus/add",
    data: {
      ...obj
    },
  })
}
//删
export function menuManage_remove(id) {
  return ajax({
    type: "get",
    url: "/system/sysMenus/del",
    data: {
      id
    },
  })
}
//改
export function menuManage_edit(obj) {
  return ajax({
    type: "POST",
    url: "/system/sysMenus/edit",
    data: {
      ...obj
    },
  })
}
// 查
export function menuManage_get() {
  return ajax({
    type: "get",
    url: "/system/sysMenus2/read/menuTree2",
  })
}
/*****菜单管理******/




/*****角色管理******/

//增 改
export function roleManage_addOrEdit(type, obj) {
  return ajax({
    type: "POST",
    url: `/system/sysRoles/${type}`,
    data: {
      ...obj
    },
  })
}
//删
export function roleManage_remove(id) {
  return ajax({
    url: "/system/sysRoles/del",
    type: "get",
    data: {
      id
    },
  })
}


//保存权限
export function roleManage_admin(roleId, ids) {
  return ajax({
    url: "/system/sysRoles/save/rolePerm",
    data: {
      roleId,
      ids
    }
  })
}
//保存菜单权限
export function roleManage_adminMenu(roleId, ids) {
  return ajax({
    url: "/system/sysMenus2/menuTreeBinding",
    data: {
      roleId,
      ids
    }
  })
}
//获取权限
export function roleManage_adminRead(roleId) {
  return ajax({
    url: `/system/sysMenus2/read/${roleId}`,
    type: "get",
  })
}

//获取当前角色权限
export function getRoleAdmin(roleId) {
  return ajax({
    url: "/system/sysRoles/read/rolePerms",
    type: "get",
    data: {
      roleId,
    },
  })
}

/*****角色管理******/

/*****组织管理******/
//单个机构
export function getOrg() {
  return ajax({
    url: "/buz/organizationBase/read/orgTree",
    type: "POST",
    data: {
      source:1,
    },
  })
}
//职级
export function getOrgRank(id) {
  return ajax({
    url: "/buz/baseRank/read/all",
    type: "POST",
    data: {
      // orgId: id
    },
  })
}
//机构管理新增业务员
export function getOrgRankJoin() {
  return ajax({
    url: "/buz/baseRankJoin/queryAllRank",
    type: "GET"
  })
}
//单个团队
export function getQuene(organizationId = 0) {
  return ajax({
    url: "/buz/organizationGroup/getSubGroup",
    type: "GET",
    data: {
      organizationId
    },
  })
}
//增
export function organization_add(obj) {
  return ajax({
    type: "POST",
    url: "/system/sysOrgans/add",
    data: {
      ...obj
    },
  })
}
//删
export function organization_remove(id) {
  return ajax({
    type: "get",
    url: "/system/sysOrgans/del",
    data: {
      id
    },
  })
}
//改
export function organization_edit(obj) {
  return ajax({
    type: "POST",
    url: "/system/sysOrgans/edit",
    data: {
      ...obj
    },
  })
}
// 查
export function organization_get() {
  return ajax({
    url: "/system/sysOrgans/read/all",
  })
}


/*****组织管理******/




/*****用户管理******/

// 查
export function user_get(obj) {
  return ajax({
    url: "/system/sysUsers/read/list",
    data: {
      ...obj,
    },
  })
}

//部门列表
export function user_tree(obj) {
  return ajax({
    url: "/system/sysOrgans/read/list",
    data: {
      ...obj,
    },
  })
}


/*****用户管理******/




/*****数据字典******/

//增
export function dir_add(obj) {
  return ajax({
    type: "POST",
    url: `/system/dic/add`,
    data: {
      ...obj
    },
  })
}
//删 单
export function dir_remove(id) {
  return ajax({
    type: "get",
    url: `/system/dic/del`,
    data: {
      id
    },
  })
}
//删 批量
export function dir_removeMany(ids) {
  return ajax({
    url: `/system/dic/batchDel`,
    data: {
      ids
    },
  })
}
//改
export function dir_edit(obj) {
  return ajax({
    type: "POST",
    url: `/system/dic/edit`,
    data: {
      ...obj
    }
  })
}
// 查
export function dir_get(obj) {
  return ajax({
    type: "POST",
    url: `/system/dic/read/list`,
    data: {
      ...obj
    }
  })
}
export function sysDic(obj) {
  return ajax({
    type: "GET",
    url: `/system/dic/read/type`,
    data: {
      ...obj
    }
  })
}

/*****数据字典******/





/*****机构管理******/
//获取机构产品
export function getMechProductList(data) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/queryUserProduct`,
    data
  })
}
//获取团队长列表
export function getQueneList(id) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/read/array`,
    data: {
      groupId: id
    }
  })
}
// 获取组织
export function getOrganizationBase(obj) {
  return ajax({
    type: "POST",
    url: `/buz/organizationBase/read/tree`,
    data:{
      source:1,
    }
  })
}
//查询单条机构信息详情
export function getOrganizationOne(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationBase/read/detail?id=${id}`,
  })
}
//业务员模糊搜索

export function getServerNames(obj) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/read/array`,
    data: {
      ...obj
    }
  })
}

//新增业务员
export function addServerUser(obj) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/add`,
    data: {
      ...obj
    }
  })
}
//删除团队
export function deleteQuene(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationGroup/logic/del`,
    data: {
      id
    }
  })
}
//删除机构
export function deleteOrganization(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationBase/logic/del`,
    data: {
      id
    }
  })
}
//编辑机构
export function editOrganization(organizationBase, organizationInfo) {
  return ajax({
    type: "POST",
    url: `/buz/organizationBase/edit`,
    data: {
      organizationBase,
      organizationInfo
    }
  })
}
//新增机构
export function addOrganization(organizationBase, organizationInfo) {
  return ajax({
    type: "POST",
    url: `/buz/organizationBase/add`,
    data: {
      organizationBase,
      organizationInfo
    }
  })
}
// 获取机构信息
export function getOrganizationInfo(data) {
  return ajax({
    type: "POST",
    contentType: "from",
    url: `/buz/organizationBase/getInfo`,
    data
  })
}

// 新增团队
export function addQuene(obj) {
  return ajax({
    type: "POST",
    url: `/buz/organizationGroup/add`,
    data: {
      ...obj
    }
  })
}
// 编辑团队
export function editQuene(obj) {
  return ajax({
    type: "POST",
    url: `/buz/organizationGroup/edit`,
    data: {
      ...obj
    }
  })
}
// 查询业务员单条
export function queryServerByOne(id) {
  return ajax({
    type: "GET",
    url: `/buz/userBase/read/detail`,
    data: {
      id
    }
  })
}
// 编辑业务员
export function editServer(obj) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/edit`,
    data: {
      ...obj
    }
  })
}
// 查询业务员分页
export function queryServerList(id, pageNo = 1, pageSize = 10, enableFlag, qualificationFlag) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/read/list`,
    data: {
      groupId: id,
      pageNo,
      pageSize,
      enableFlag,
      qualificationFlag
    }
  })
}

// 删除业务员
export function deleteServerList(id) {
  return ajax({
    type: "GET",
    url: `/buz/userBase/logic/del`,
    data: {
      id
    }
  })
}
// 获取字典模板
export function getOrganTemplate(code) {
  return ajax({
    type: "post",
    url: "/system/dic/read/dicList",
    data: {
      code,
    },
  })
}
// 全部导出
export function serverExportAll(groupId) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/userBase/batch/export`,
    data: {
      isAll: true,
      groupId,
      ids: []
    }
  })
}
// -商户产品导出
export function productExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/commission/sys/product/export`,
    data
  })
}
// 团队详情
export function queryQueneDetail(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationGroup/read/detail`,
    data: {
      id
    }
  })
}
// 团队详情 批量认证
export function approveMany(ids) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/approve`,
    data: {
      ids
    }
  })
}
// 团队详情 认证单条
export function approveOne(id) {
  return ajax({
    type: "POST",
    url: `/buz/userBase/approveOne`,
    data: {
      id,
    }
  })
}
//设置团队长
export function setLeader(groupId, leaderId, isLeader) {
  return ajax({
    type: "GET",
    url: `/buz/organizationGroup/setLeader`,
    data: {
      groupId,
      leaderId,
      isLeader
    }
  })
}
// 手机号搜索
export function organizationBaseSearchByMobile(obj) {
  return ajax({
    type: "GET",
    url: `/buz/organizationBase/search`,
    data: {
      ...obj
    }

  })
}

//机构批量上传
export function uploadOrgMech(formData, onUploadProgress) {
  return ajax({
    url: "/buz/userBase/batch/upload",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
//根据批次号获取缓存分页
export function getCacheList(batchNo, pageNo, pageSize) {
  return ajax({
    url: "/buz/userBase/batch/get",
    type: "GET",
    data: {
      batchNo,
      pageNo,
      pageSize
    }
  })
}

//确定批量导入
export function importCacheList(batchNo) {
  return ajax({
    url: "/buz/userBase/batch/import",
    type: "GET",
    data: {
      batchNo
    }
  })
}
//获取银行卡信息
export function getAcconut(item) {
  return ajax({
    url: "/buz/merchantWithdrawLog/getBank",
    type: "GET",
    data: {
      cardNo:item
    }
  })
}
//获取服务费模板
export function getServerTemplate(orgId, templateType) {
  return ajax({
    url: "/buz/template/getOrgTemplateList",
    type: "GET",
    data: {
      orgId,
      templateType
    }
  })
}

//机构树形结构
export function getOrgTree() {
  return ajax({
    url: "/buz/organizationBase/read/orgTree",
    type: "POST",
    data: {
      source:1,
    },
  })
}
/*****机构管理******/



/*****商品库******/
//根据姓名模糊搜索
export function mechSearchByNname(userName) {
  return ajax({
    url: "/buz/userBase/queryUserByName",
    type: "GET",
    data: {
      userName
    }
  })
}
//导出
export function mechExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/commission/product/export`,
    data
  })
}

//商品分页
export function getProductBase(obj) {
  return ajax({
    url: "/buz/productBase/read/list",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//赠险产品分页
export function getProductGift(obj) {
  return ajax({
    url: "/buz/giftProduct/queryGiftPage",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//查保险公司
export function getAllCompany() {
  return ajax({
    url: "/buz/molInsuranceCompany/getCompanyList",
    type: "GET",
  })
}
export function getAgreeAllCompany() {
  return ajax({
    url: "/buz/molInsuranceCompany/getCompanyList",
    type: "GET",
  })
}
//一级标签
export function getFirstTag() {
  return ajax({
    url: "/buz/productTheme/array/first",
    type: "GET",
  })
}
//二级标签
export function getSecondTag(parentId) {
  return ajax({
    url: "/buz/productTheme/array/second",
    type: "GET",
    data: {
      parentId
    }
  })
}

//商品资源 查询产品资料
export function getProductMaterials(productCode) {
  return ajax({
    url: "/buz/productMaterial/queryMaterials",
    type: "GET",
    data: {
      productCode
    }
  })
}
//下载全部PDF
export function dowloadPdf(productCode) {
  return ajax({
    url: "/buz/productMaterial/downloadMaterials",
    type: "GET",
    All: true,
    forced: true,
    responseType: "blob",
    data: {
      productCode,
    }
  })
}
//获取海报
export function getPosts(productCode) {
  return ajax({
    url: "/buz/productMaterial/queryPosters",
    type: "GET",
    data: {
      productCode,
    }
  })
}
/*****商品库******/




/*****商户管理******/
/*****保单管理******/
//保单佣金
export function getPolicyCommission(policyNo) {
  return ajax({
    url: "/buz/policy/queryCommission",
    type: "GET",
    data: {
      policyNo
    }
  })
}
//保单
export function insureExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/policy/policyExport`,
    data
  })
}

export function delEnterPolicy(data) {
  return ajax({
    url: "/buz/offlinePolicy/delEnterPolicy",
    type: "GET",
    data
  })
}
//获取电子保单
export function getProUrl(policyNo) {
  return ajax({
    url: "/buz/policy/getDownloadUrl",
    type: "GET",
    data: {
      policyNo
    }
  })
}
//商户产品页面
export function getMechCategoryPro(data) {
  return ajax({
    url: "/buz/productBase/queryMerchantProduct",
    type: "POST",
    data
  })
}

//查询商户产品佣金
export function queryMerchantProductRate(productCode, organizationId) {
  return ajax({
    url: "/buz/commission/queryMerchantProductRate",
    type: "GET",
    data: {
      productCode,
      organizationId
    }
  })
}

//获取产品分类
export function getMechCategory(productCode) {
  return ajax({
    url: "/buz/productThemeJoin/queryProductTheme",
    type: "GET",
    data: {
      productCode
    }
  })
}
//保存产品分类
export function saveMechCategory(productCode, themeIds) {
  return ajax({
    url: "/buz/productThemeJoin/saveProductTheme",
    type: "post",
    data: {
      productCode,
      themeIds
    }
  })
}
//保单 列表
export function getInsureOrderList(data) {
  return ajax({
    url: "/buz/policy/read/list",
    type: "POST",
    data
  })
}
//保单 统计
export function getInsureStatistics(data) {
  return ajax({
    url: "/buz/policy/statistics",
    type: "POST",
    data
  })
}
//保单 详情
export function getInsureDetail(policyNo) {
  return ajax({
    url: "/buz/policy/read/detail",
    type: "GET",
    data: {
      policyNo
    }
  })
}
//订单管理
export function getOrderList(data) {
  return ajax({
    url: "/buz/order/read/list",
    type: "POST",
    data
  })
}
//订单详情
export function getOrdeDetail(orderNo) {
  return ajax({
    url: "/buz/order/read/detail",
    type: "GET",
    data: {
      orderNo
    }
  })
}
//订单统计
export function getOrderStatistics(data) {
  return ajax({
    url: "/buz/order/statistics",
    type: "POST",
    data
  })
}
//获取商户列表
export function getCustomList(data) {
  return ajax({
    url: "/buz/merchantBase/read/array",
    type: "POST",
    data
  })
}
//获取商户号
export function getMechNo() {
  return ajax({
    url: "/buz/merchantBase/read/getMerchantNo",
    type: "GET",

  })
}
// 账户管理
//查询用户拥有的角色
export function merchantChangeRole(userId, roleIds) {
  return ajax({
    url: `/buz/usersExt/roles/modify`,
    type: "POST",
    data: {
      userId,
      roleIds
    }
  })
}

export function getMerchantAccountRole(userId) {
  return ajax({
    url: "/buz/usersExt/roleList",
    type: "GET",
    data: {
      userId
    }
  })
}
//查询商户菜单
export function getMerchantMenuTree(userId) {
  return ajax({
    url: "/buz/rolesExt/read/menuTree",
    type: "GET",
    data: {
      userId
    }
  })
}
//查询列表
export function getMerchantAccount(obj) {
  return ajax({
    url: "/buz/usersExt/read/list",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//详情
export function getMerchantAccountDetail(id) {
  return ajax({
    url: "/buz/usersExt/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//新增
export function getMerchantAccountAdd(obj) {
  return ajax({
    url: "/buz/usersExt/add",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//修改
export function getMerchantAccountEdit(obj) {
  return ajax({
    url: "/buz/usersExt/edit",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//查询机构角色列表
export function getMerchantRoleArr(buzOrganId) {
  return ajax({
    url: "/buz/rolesExt/read/array",
    type: "GET",
    data: {
      buzOrganId
    }
  })
}
// 角色管理

//角色列表
export function getMerchantRole(obj) {
  return ajax({
    url: "/buz/rolesExt/read/list",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//拥有的角色列表
export function hasGetRoleList(userId) {
  return ajax({
    url: "/buz/usersExt/roleList",
    type: "GET",
    data: {
      userId
    }
  })
}
//角色详情
export function getMerchantRoleDetail(id) {
  return ajax({
    url: "/buz/rolesExt/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//角色新增
export function getMerchantRoleAdd(obj) {
  return ajax({
    url: "/buz/rolesExt/add",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//角色编辑
export function getMerchantRoleEdit(obj) {
  return ajax({
    url: "/buz/rolesExt/edit",
    type: "POST",
    data: {
      ...obj
    }
  })
}


//商户管理
//查询商户
export function getMerchantList(obj) {
  return ajax({
    url: "/buz/merchantBase/read/list",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//新增商户
export function addMerchantList(obj) {
  return ajax({
    url: "/buz/merchantBase/add",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//编辑商户
export function editMerchantList(obj) {
  return ajax({
    url: "/buz/merchantBase/edit",
    type: "POST",
    data: {
      ...obj
    }
  })
}

//商户详情
export function detailMerchantList(id) {
  return ajax({
    url: "/buz/merchantBase/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
/*****商户管理******/



/*****平台产品库******/
//查询档次列表
export function getProductGradeList(productCode) {
  return ajax({
    url: "/buz/gradeAddition/read/list",
    type: "GET",
    data: {
      productCode
    }
  })
}
//档次列表新增
export function addProductGradeList(data) {
  return ajax({
    url: "/buz/gradeAddition/add",
    type: "POST",
    data
  })
}
//档次列表编辑
export function editProductGradeList(data) {
  return ajax({
    url: "/buz/gradeAddition/edit",
    type: "POST",
    data
  })
}
//档次列表删除
export function delProductGradeList(data) {
  return ajax({
    url: "/buz/gradeAddition/del",
    type: "GET",
    data
  })
}
//查询产品分类
export function getProductCategory(data) {
  return ajax({
    url: "/buz/productTheme/read/list",
    type: "POST",
    data
  })
}
//新增产品分类
export function addProductCategory(data) {
  return ajax({
    url: "/buz/productTheme/add",
    type: "POST",
    data
  })
}
//删除产品分类
export function deleteProductCategory(id) {
  return ajax({
    url: "/buz/productTheme/del",
    type: "GET",
    data: {
      id
    }
  })
}
//修改产品分类
export function editProductCategory(data) {
  return ajax({
    url: "/buz/productTheme/edit",
    type: "POST",
    data
  })
}
//查询trans产品列表
export function getProductCategoryList(themeId) {
  return ajax({
    url: "/buz/productThemeJoin/queryProduct",
    type: "GET",
    data: {
      themeId
    }
  })
}
//保存trans产品列表
export function saveProductCategoryList(parentId, themeId, productCodes) {
  return ajax({
    url: "/buz/productThemeJoin/saveThemeProduct",
    type: "POST",
    data: {
      parentId,
      themeId,
      productCodes
    }
  })
}
export function productManageGetList(obj) {
  return ajax({
    // url: "/buz/productBase/read/page",
    url: "/buz/productBase/offline/read/page",
    type: "POST",
    data: {
      ...obj
    }
  })
}

//修改产品
export function productManageEdit(obj) {
  return ajax({
    url: "/buz/productBase/edit",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//修改产品
export function productManageEditRank(obj) {
  return ajax({
    url: "/buz/productBase/rank",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//新增产品
export function productManageAdd(obj) {
  return ajax({
    url: "/buz/productBase/offline/enter",
    // url: "/buz/productBase/add",
    type: "POST",
    data: {
      ...obj
    }
  })
}
//产品详情
export function productManageDetail(id) {
  return ajax({
    url: "/buz/productBase/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//查询附加险
export function getProductAdditional(data) {
  return ajax({
    url: "/buz/productAdditional/read/list",
    type: "POST",
    data
  })
}
//编辑附加险
export function editProductAdditional(data) {
  return ajax({
    url: "/buz/productAdditional/edit",
    type: "POST",
    data
  })
}
//新增附加险
export function addProductAdditional(data) {
  return ajax({
    url: "/buz/productAdditional/add",
    type: "POST",
    data
  })
}
//删除附加险
export function deleteProductAdditional(id) {
  return ajax({
    url: "/buz/productAdditional/logic/del",
    type: "GET",
    data: {
      id
    }
  })
}
//查询资料所有类型
export function productManageGetAllType() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "BASIC_MATERIAL"
    }
  })
}
//开户银行
export function getBank() {
  return ajax({
    url: "/system/dic/read/dicList",
    type: "POST",
    data: {
      code: "BANK_TYPE"
    }
  })
}
//新增资料
export function addManageGetRecourse(productCode, materials) {
  return ajax({
    url: "/buz/productMaterial/add",
    type: "POST",
    data: {
      productCode,
      materials
    }
  })
}
//保存海报
export function savePosts(productCode, materials) {
  return ajax({
    url: "/buz/productMaterial/add",
    type: "POST",
    data: {
      productCode,
      materials
    }
  })
}
//同步产品中心产品信息
export function syncFromCenter(productCode) {
  return ajax({
    url: "/buz/productBase/syncFromCenter",
    type: "GET",
    data: {
      productCode
    }
  })
}
//查看资料
export function lookManageGetRecourse(productCode) {
  return ajax({
    url: "/buz/productMaterial/queryMaterials",
    type: "GET",
    data: {
      productCode
    }
  })
}
//查看海报
export function lookManagePost(productCode) {
  return ajax({
    url: "/buz/productMaterial/queryPosters",
    type: "GET",
    data: {
      productCode
    }
  })
}
//查看档次
export function getProductGrade(obj) {
  return ajax({
    url: "/buz/programBase/queryProductGrade",
    type: "POST",
    data: obj
  })
}
//查看档次树
export function getProductGradeTree(productCode, isMain) {
  return ajax({
    url: "/buz/programBase/queryGradeTree",
    type: "GET",
    data: {
      productCode,
      isMain
    }
  })
}
/***档次列表 */
//获取档次列表
export function getGradePageList(data) {
  return ajax({
    url: "/buz/programBase/queryList",
    type: "POST",
    data
  })
}

export function addGradeList(data) {
  return ajax({
    url: "/buz/programBase/addGrade",
    type: "POST",
    data
  })
}
export function deleteGradeList(data) {
  return ajax({
    url: "/buz/programBase/del",
    type: "GET",
    data
  })
}


//新增档次

export function addProductGradeNew(data) {
  return ajax({
    url: "/buz/programBase/addGrade",
    type: "POST",
    data
  })
}
//删除档次

export function deleteProductGrade(data) {
  return ajax({
    url: "/buz/commission/delProductGrade",
    type: "GET",
    data
  })
}
//初始化佣金

export function initProductGradeNew(data) {
  return ajax({
    url: "/buz/commission/initCommission",
    type: "POST",
    data
  })
}
// 初始化线下主险佣金
export function initCommissionOffline(data) {
  return ajax({
    url: "/buz/commission/offline/initCommission",
    type: "POST",
    data
  })
}

//佣金列表
export function getCommissionList(productCode, templateId) {
  return ajax({
    url: "/buz/commission/queryTemplateCommission",
    type: "GET",
    data: {
      productCode,
      templateId
    }
  })
}
//佣金模板tab
export function getCommissionTabs(productCode) {
  return ajax({
    url: "/buz/templateProduct/queryTemplate",
    type: "GET",
    data: {
      productCode
    }
  })
}
//新增无档次无方案佣金
export function addCommissionTabs(templateId, productCode, commissions) {
  return ajax({
    url: "/buz/commission/addNoneCommission",
    type: "POST",
    data: {
      templateId,
      productCode,
      commissions
    }
  })
}
//佣金费率修改
export function editCommission(data) {
  return ajax({
    url: "/buz/commission/sys/modify",
    type: "POST",
    data
  })
}
//订单导出
export function orderExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/order/export`,
    data

  })
}
/*******公告******/
//列表
export function chatMangeList(data) {
  return ajax({
    type: "POST",
    url: `/buz/noticeConfig/queryNewMsgList`,
    data
  })
}
//公告详情
export function chatMangeDetail(id) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/read/msg`,
    data: {
      id
    }
  })
}
//平台公告详情
export function chatPlatMangeDetail(platformId) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/platform/read/msg`,
    data: {
      platformId
    }
  })
}
//平台公告详情
export function chatPlatNotSyncMangeDetail(platformId) {
  return ajax({
    type: "GET",
    url: `/buz/organizationMessage/read/detail?id=${platformId}`,
  })
}
//查询未读数
export function lookChatReadNum(tabCode) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/queryUnRead`,
    data: {
      tabCode
    }
  })
}
export function searchPro(productName) {
  return ajax({
    type: "GET",
    url: `/buz/productBase/queryProducts`,
    data: {
      productName
    }
  })
}
//运营后台消息公告
//列表
export function opeatechatMangeList(data) {
  return ajax({
    type: "POST",
    url: `/buz/organizationMessage/read/list`,
    data
  })
}
//详情
export function opeatechatMangeDetail(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationMessage/read/detail`,
    data: {
      id
    }
  })
}
//编辑
export function opeatechatMangeEdit(data) {
  return ajax({
    type: "POST",
    url: `/buz/organizationMessage/edit`,
    data
  })
}
//新增
export function opeatechatMangeAdd(data) {
  return ajax({
    type: "POST",
    url: `/buz/organizationMessage/add`,
    data
  })
}
//删除
export function opeatechatMangeDele(id) {
  return ajax({
    type: "GET",
    url: `/buz/organizationMessage/del`,
    data: {
      id
    }
  })
}
/*******财务管理 商户******/
// 我的导出
export function myExportAll(totalId, commissionPeriod) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementTotal/settlement/export`,
    data: {
      totalId,
      commissionPeriod
    }
  })
}
// 结算资料下载
export function userDownloadZip(data) {
  return ajax({
    url: "/buz/userCashWithdrawLog/downloadZip",
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    data
  })
}
//结算函下载
export function downloadInfo(totalId, path) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementDetail/settleConfirmDownload`,
    data: {
      totalId,
      path
    }
  })
}
//结算明细导出
export function setDetailExportAll(totalId) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementTotal/settleDetail/export`,
    data: {
      totalId
    }
  })
}
//下级机构导出
export function nextExportAll(data) {
  return ajax({
    type: "GET",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/settlementTotal/subSettlement/export`,
    data
  })
}
//我的收入结算查询
export function myMerchantTotal(data) {
  return ajax({
    url: "/buz/settlementDetail/getMerchantTotal",
    type: "POST",
    data
  })
}
//下级机构已结算查询
export function orgMerchantTotal(data) {
  return ajax({
    url: "/buz/settlementDetail/getOrganTotal",
    type: "POST",
    data
  })
}
//下级机构待结算
export function orgMerchantWait(data) {
  return ajax({
    url: "/buz/settlementDetail/getOrganWaitTotal",
    type: "POST",
    data
  })
}

//下级机构可提现收入
export function orgMerchantListSubOrgan(data) {
  return ajax({
    url: "/buz/withdrawTotal/read/listSubOrgan",
    type: "POST",
    data
  })
}
//业务员可提现
export function serverMerchantListSubOrgan(data) {
  return ajax({
    url: "/buz/withdrawTotal/read/listUser",
    type: "POST",
    data
  })
}
//业务员已结算
export function serverHasMerchantList(data) {
  return ajax({
    url: "/buz/settlementUserDetail/read/list",
    type: "POST",
    data
  })
}
//业务员待结算
export function serverWaitMerchantList(data) {
  return ajax({
    url: "/buz/settlementUserDetail/read/waitList",
    type: "POST",
    data
  })
}
//是否可提现

export function isCanExport() {
  return ajax({
    url: "/buz/withdrawTotal/checkAmount",
    type: "GET",

  })
}
//提现记录
//下级机构待结算收入
export function waitWithdrawAfter() {
  return ajax({
    url: "/buz/settlementTotal/getWaitAmount",
    type: "GET",

  })
}
//下级结算(商户给机构和业务员结算)
export function withdrawSettlementSub(data) {
  return ajax({
    url: "/buz/settlementTotal/settlementSub",
    type: "POST",
    data
  })
}
//我的提现
export function myWithdrawLog(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/listMy",
    type: "POST",
    data
  })
}
//机构提现
export function downWithdrawLog(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/listOrgan",
    type: "POST",
    data
  })
}
//机构提现详情
export function downWithdrawLogDetail(id) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/organDetail",
    type: "GET",
    data: {
      id
    }
  })
}
//机构提现审核
export function downWithdrawLogDetailConfirm(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/checkOrgan",
    type: "POST",
    data
  })
}
//业务员提现
export function serverWithdrawLog(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/listUser",
    type: "POST",
    data
  })
}

//业务员提现2
export function userCashWithdrawLog(data) {
  return ajax({
    url: "/buz/userCashWithdrawLog/read/list",
    type: "POST",
    data
  })
}
//业务员提现2
export function userCashWithdrawAudit(data) {
  return ajax({
    url: "/buz/userCashWithdrawLog/edit",
    type: "POST",
    data
  })
}
//业务员提现详情
export function serverWithdrawLogDetail(id) {
  return ajax({
    url: "/buz/userCashWithdrawLog/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//业务员提现审核
export function serverithdrawLogDetailConfirm(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/checkUser",
    type: "POST",
    data
  })
}
//获取商户可提现金额
export function getAvailableAmountWithdrawLog() {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/getAmount",
    type: "GET",

  })
}
//查询当前商户或机构的银行账户信息
export function getBankInfo() {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/info",
    type: "GET",

  })
}
//新增提现记录 商户
export function addWithdrawLog(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/add",
    type: "POST",
    data

  })
}
//机构提现
export function organizationWithdrawLog(data) {
  return ajax({
    url: "/buz/organizationWithdrawLog/add",
    type: "POST",
    data

  })
}
/*******财务管理******/


/*******财务管理******/
//佣金结算
export function getSettlementList(data) {
  return ajax({
    url: "/buz/settlementTotal/read/list",
    type: "POST",
    data
  })
}
//佣金结算明细
export function getSettlementDetail(data) {
  return ajax({
    url: "/buz/settlementTotal/read/detail",
    type: "POST",
    data
  })
}
//待结算
export function getwaitSettlementDetail(data) {
  return ajax({
    url: "/buz/settlementTotal/read/waitList",
    type: "POST",
    data
  })
}
//添加到待结算
export function addToSettlement(data) {
  return ajax({
    url: "/buz/settlementTotal/addSettlement",
    type: "POST",
    data
  })
}
//结算统计
export function getToSettlementStat(id) {
  return ajax({
    url: "/buz/settlementTotal/read/stat",
    type: "GET",
    data: {
      id
    }
  })
}
//结算查询分页
export function getSettlementLog(data) {
  return ajax({
    url: "/buz/settlementLog/read/list",
    type: "POST",
    data
  })
}
//结算详情
export function getSettlementLogDetail(policyNo) {
  return ajax({
    url: `/buz/settlementLog/read/settlementLogDeTail?policyNo=${policyNo}`,
    type: "GET",

  })
}
//确认结算
export function confirmSettlement(id) {
  return ajax({
    url: `/buz/settlementTotal/settlement?id=${id}`,
    type: "GET",

  })
}
//退保
export function surrenderList(id, policyNo) {
  return ajax({
    url: "/buz/settlementTotal/surrender",
    type: "GET",
    data: {
      id,
      policyNo
    }
  })
}
//删除
export function delPendingSettlement(id, policyNo) {
  return ajax({
    url: "/buz/settlementTotal/delPendingSettlement",
    type: "GET",
    data: {
      id,
      policyNo
    }
  })
}


//提现申请
export function getMerchantApply(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/list",
    type: "POST",
    data
  })
}
//提现申请详情
export function getMerchantApplyDetail(id) {
  return ajax({
    url: "/buz/merchantWithdrawLog/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//提现审核
export function getMerchantApplyConfirm(data) {
  return ajax({
    url: "/buz/merchantWithdrawLog/edit",
    type: "POST",
    data
  })
}
/*******财务管理******/



/*******保险公司管理******/
export function getInuserCompanyList(data) {
  return ajax({
    url: "/buz/insuranceCompany/read/list",
    type: "POST",
    data
  })
}
//编辑
export function editInuserCompanyList(data) {
  return ajax({
    url: "/buz/insuranceCompany/edit",
    type: "POST",
    data
  })
}
//新增
export function addInuserCompanyList(data) {
  return ajax({
    url: "/buz/insuranceCompany/add",
    type: "POST",
    data
  })
}
//删除
export function removeInuserCompanyList(id) {
  return ajax({
    url: "/buz/insuranceCompany/del",
    type: "GET",
    data: {
      id
    }
  })
}
/*******保险公司管理******/


/*******产品排序******/
export function saveRankAll(productCodes) {
  return ajax({
    url: "/buz/productBase/rank",
    type: "POST",
    data: {
      productCodes
    }
  })
}
export function saveRankOther(productCodes, themeId) {
  return ajax({
    url: "/buz/productThemeJoin/rank",
    type: "POST",
    data: {
      productCodes,
      themeId
    }
  })
}

/*******产品排序******/


/*******系统设置******/
//产品级别

export function getSysRank(data) {
  return ajax({
    url: "/buz/organizationLevel/read/list",
    type: "POST",
    data
  })
}

export function saveSysRank(items) {
  return ajax({
    url: "/buz/organizationLevel/save",
    type: "POST",
    data: {
      items
    }
  })
}
/*******系统设置******/


/*******协议管理******/
//类表

export function getAgreementList(data) {
  return ajax({
    // url: "/buz/agreement/read/list",
    url: "/buz/agreement/read/list",
    type: "POST",
    data
  })
}


export function getProductList(infoId) {
  return ajax({
    url: "/buz/agreementProduct/getAllProducts",
    type: "GET",
    data: {
      infoId
    }
  })
}
export function addAgreementList(data) {
  return ajax({
    url: "/buz/agreement/add",
    type: "POST",
    data
  })
}
export function deleAgreementList(id) {
  return ajax({
    url: "/buz/agreement/del",
    type: "GET",
    data: {
      id
    }
  })
}
export function agreementDetail(id) {
  return ajax({
    url: "/buz/agreement/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
export function editAgreement(data) {
  return ajax({
    url: "/buz/agreement/edit",
    type: "POST",
    data
  })
}
//获取公司名
export function getCompanyName() {
  return ajax({
    url: "/system/info/userinfo",
    type: "GET"
  })
}
//查询协议产品
export function getAgreementPro(companyCode) {
  return ajax({
    url: "/buz/agreementProduct/getProducts",
    type: "GET",
    data: {
      companyCode
    }
  })
}
//查询协议产品列表
export function getAgreementProList(data) {
  return ajax({
    url: "/buz/agreementProduct/read/list",
    type: "POST",
    data
  })
}
export function getProList(data) {
  return ajax({
    url: "/buz/molProductBase/getProtocolProduct",
    type: "POST",
    data: data
  })
}
//编辑协议产品列表
export function editAgreementProList(data) {
  return ajax({
    url: "/buz/agreementProduct/edit",
    type: "POST",
    data
  })
}
//删除协议产品
export function deleAgreementProList(id) {
  return ajax({
    url: "/buz/agreementProduct/del",
    type: "GET",
    data: {
      id
    }
  })
}
//新增协议产品
export function addAgreementPro(data) {
  return ajax({
    url: "/buz/agreementProduct/add",
    type: "POST",
    data
  })
}
//查询险种类型
export function getProType() {
  return ajax({
    url: "/buz/productTheme/array/first",
    type: "GET",

  })
}




//协议文件
//列表
//查询协议产品列表
export function getFileList(data) {
  return ajax({
    url: "/buz/agreementInfo/read/list",
    type: "POST",
    data
  })
}
export function addFileList(data) {
  return ajax({
    url: "/buz/agreementInfo/add",
    type: "POST",
    data
  })
}
export function editFileList(data) {
  return ajax({
    url: "/buz/agreementInfo/edit",
    type: "POST",
    data
  })
}
export function deleFileList(id) {
  return ajax({
    url: "/buz/agreementInfo/del",
    type: "GET",
    data: {
      id
    }
  })
}
export function getFileListDetail(id) {
  return ajax({
    url: "/buz/agreementInfo/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
export function fileExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/agreementInfo/export`,
    data
  })
}
// //编辑协议产品列表
// export function editAgreementProList(data) {
//     return ajax({
//         url: "/buz/agreementProduct/edit",
//         type: "POST",
//         data
//     })
// }
// //删除协议产品
export function deleAgreeList(id) {
  return ajax({
    url: "/buz/agreementProduct/del",
    type: "GET",
    data: {
      id
    }
  })
}
// //新增协议产品
// export function addAgreementPro(data) {
//     return ajax({
//         url: "/buz/agreementProduct/add",
//         type: "POST",
//         data
//     })
// }
// //查询险种类型
// export function getProType() {
//     return ajax({
//         url: "/buz/productTheme/array/first",
//         type: "GET",

//     })
// }
/*******系统设置******/


/*******banner管理******/
export function getBanner(data) {
  return ajax({
    url: "/buz/generalConfig/read/list",
    type: "POST",
    data
  })
}
export function setBanner(data) {
  return ajax({
    url: "/buz/generalConfig/edit",
    type: "POST",
    data
  })
}
export function addBanner(data) {
  return ajax({
    url: "/buz/generalConfig/add",
    type: "POST",
    data
  })
}
export function removeBanner(id) {
  return ajax({
    url: "/buz/generalConfig/del",
    type: "GET",
    data: {
      id
    }
  })
}
export function getBannerDetail(id) {
  return ajax({
    url: "/buz/generalConfig/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
//首页获取banner
export function getBannerList() {
  return ajax({
    url: "/buz/generalConfig/queryBanner",
    type: "GET",
    data: {
      position: "INDEX_BANNER"
    }
  })
}
/*******banner管理******/


/*******员工管理******/

export function getStaffList(data) {
  return ajax({
    url: "/buz/userBase/read/list",
    type: "POST",
    data
  })
}
export function getStaffDetail(id) {
  return ajax({
    url: "/buz/userBase/read/detail",
    type: "GET",
    data: {
      id
    }
  })
}
export function editStaffDetail(data) {
  return ajax({
    url: "/buz/userBase/edit",
    type: "POST",
    data
  })
}
export function deleteStaffDetail(id) {
  return ajax({
    url: "/buz/userBase/logic/del",
    type: "GET",
    data: {
      id
    }
  })
}
export function lookHTDetail(id) {
  return ajax({
    url: "/buz/userBase/getContract",
    type: "GET",
    data: {
      id
    }
  })
}
export function setHTDetail(data) {
  return ajax({
    url: "/buz/userBase/editContract",
    type: "POST",
    data
  })
}
/*******员工管理******/


/*******奖惩培训******/

export function getRewardList(data) {
  return ajax({
    url: "/buz/userRewardPunishment/read/list",
    type: "POST",
    data
  })
}

export function editRewardDetail(data) {
  return ajax({
    url: "/buz/userRewardPunishment/edit",
    type: "POST",
    data
  })
}
export function addRewardDetail(data) {
  return ajax({
    url: "/buz/userRewardPunishment/add",
    type: "POST",
    data
  })
}
export function deleteRewardDetail(id) {
  return ajax({
    url: "/buz/userRewardPunishment/logic/del",
    type: "GET",
    data: {
      id
    }
  })
}


/*******奖惩培训******/



/*******职业资格******/

export function getMagCertificateList(data) {
  return ajax({
    url: "/buz/userBase/manage/list",
    type: "POST",
    data
  })
}
export function getChangeList(data) {
  return ajax({
    url: "/buz/certificateChangeRecord/read/list",
    type: "POST",
    data
  })
}
export function updateCertificateNumber(data) {
  return ajax({
    url: "/buz/userBase/updateCertificateNumber",
    type: "POST",
    data
  })
}
export function cancelCertificateNumber(id) {
  return ajax({
    url: "/buz/userBase/cancelCertificateNumber",
    type: "GET",
    data: {
      id
    }
  })
}

/*******职业资格******/

/*******薪资移动******/

export function getSalaryRList(data) {
  return ajax({
    url: "/buz/userSalaryRecord/read/list",
    type: "POST",
    data
  })
}

export function editSalaryRDetail(data) {
  return ajax({
    url: "/buz/userSalaryRecord/edit",
    type: "POST",
    data
  })
}
export function addSalaryRDetail(data) {
  return ajax({
    url: "/buz/userSalaryRecord/add",
    type: "POST",
    data
  })
}
export function deleteSalaryRDetail(id) {
  return ajax({
    url: "/buz/userSalaryRecord/deprecated",
    type: "GET",
    data: {
      id
    }
  })
}


/*******薪资移动******/

/*******黑名单******/

export function queryblankUserName(userName, isBlack) {
  return ajax({
    url: "/buz/userBase/queryUserExtByName",
    type: "GET",
    data: {
      userName,
      isBlack: isBlack ? true : false
    }
  })
}

/*******黑名单******/

//协议管理下载
export function downloadFile(name, path) {
  return ajax({
    url: "/buz/agreementInfo/download",
    type: "GET",
    All: true,
    forced: true,
    responseType: "blob",
    data: {
      name,
      path
    }
  })
}



//导出
export function offlineInsureListExport(ids) {
  return ajax({
    url: "/buz/offlinePolicy/batch/export",
    type: "POST",
    data: {
      ids
    },
    forced: true,
    responseType: "blob",
    All: true,
  })
}
//上传

export function offlineUpload(path) {
  return ajax({
    url: "/buz/offlinePolicy/batch/upload",
    type: "GET",
    data: {
      path
    }
  })
}
//批量导入

export function offlineExportIn(batchNo) {
  return ajax({
    url: "/buz/offlinePolicy/batch/import",
    type: "GET",
    data: {
      batchNo
    }
  })
}
//新增

export function offlineAddList(data) {
  return ajax({
    url: "/buz/offlinePolicy/add",
    type: "POST",
    data
  })
}
//编辑

export function offlineEditList(data) {
  return ajax({
    url: "/buz/offlinePolicy/edit",
    type: "POST",
    data
  })
}
//删除

export function offlinedeleList(id) {
  return ajax({
    url: "/buz/offlinePolicy/del",
    type: "GET",
    data: {
      id
    }
  })
}
/*******线下保单管理******/


/**运营后台活动管理**/
export function requestList(data) {
  return ajax({
    url: "/buz/activity/read/list",
    type: "POST",
    data
  })
}

export function requestActivityList(data) {
  return ajax({
    url: "/buz/actProduct/read/list",
    type: "GET",
    data
  })
}


// 结算查询导出
export function exportSettlementQuery(data) {
  return ajax({
    url: "/buz/settlementLog/export",
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    data
  })
}


//合同导出
export function exportContract(data) {
  return ajax({
    url: "/buz/merchantContract/export",
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    data
  })
}

/*******财务管理  业务员薪酬******/


export function getSalesmanSalaryList(data) {
  return ajax({
    url: "/buz/userSalaryDetail/read/list",
    type: "POST",
    data
  })
}

export function querySettleNames(data) {
  return ajax({
    url: "/buz/baseUserSalary/querySettleNames",
    type: "GET",
    data
  })
}
export function baseUserSalarySend(data) {
  return ajax({
    url: "/buz/baseUserSalary/send",
    type: "POST",
    data
  })
}
export function userSalaryDetailSettle(data) {
  return ajax({
    url: "/buz/userSalaryDetail/settle",
    type: "POST",
    data
  })
}
export function salesmanDetail(data) {
  return ajax({
    url: "/buz/userSalaryDetail/read/detail",
    type: "POST",
    data
  })
}
export function userSalaryDetailCancel(data) {
  return ajax({
    url: "/buz/userSalaryDetail/cancel",
    type: "GET",
    data
  })
}
export function cancelSettlement(data) {
  return ajax({
    url: "/buz/userSalaryDetail/cancel/settlement",
    type: "POST",
    data
  })
}
